import React from 'react';

import { Menu, MenuItem, ListItemIcon, Typography, ListItemText, Divider } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import UploadIcon from '@material-ui/icons/CloudUpload';
import NewIcon from '@material-ui/icons/CreateNewFolder';
import NewClientIcon from '@material-ui/icons/People';
import RenameIcon from '@material-ui/icons/Adjust';
import DownloadIcon from '@material-ui/icons/CloudDownload';
import DownloadAllIcon from '@material-ui/icons/CloudDownloadTwoTone';
import AllowMultipleDownloadIcon from '@material-ui/icons/PanoramaFishEye';
import ViewIcon from '@material-ui/icons/TextRotateUp';

const VIEWABLETYPES = ['pdf', 'docx', 'xlst', 'png', 'jpeg', 'bmp'];

export function ContextMenu(props) {

    const { newClient, view, download, create, rename, upload, onDelete,
        node, multipleNodeIds, isAdmin, pos, onClose, cut, toCut, paste } = props;

    const isClient = node && node.type === 'client';
    const isFolder = node && node.hasChildren;
    const isFile = node && !node.hasChildren;
    const isViewable = node && VIEWABLETYPES.indexOf(node.type) > -1;
    const name = node && node.name;

    const isAllowNewClient = node && isAdmin && isClient;
    const isAllowNewFolder = node && isAdmin && isFolder;
    const isAllowRename = node && isAdmin;
    const isAllowPreview = node && isFile && isViewable;
    const isAllowDownload = (node && isFile) || (multipleNodeIds && multipleNodeIds.length > 0);
    const isAllowUpload = node && ((isAdmin && isFolder) || (name && name.includes("Upload")));
    //const isAllowDelete = node && isAdmin;
    const isAllowDelete = (isAdmin && node) || (isAdmin && multipleNodeIds && multipleNodeIds.length > 0);

    const isAllowCut = isAdmin && ((node && isFile) || (multipleNodeIds && multipleNodeIds.length > 0));
    const isAllowPaste = isAdmin &&  node && isFolder && toCut && toCut.length > 0;

    var downloadOrDeleteName = name;
    if (multipleNodeIds && multipleNodeIds.length > 0) {
        downloadOrDeleteName = `The ${multipleNodeIds.length} selected files`;
    }

    return (
        <Menu id='context-menu' anchorOrigin={{ vertical: 'top', horizontal: 'left' }} transformOrigin={{ vertical: 'top', horizontal: 'left' }}
            anchorPosition={pos} anchorReference='anchorPosition'
            open={Boolean(pos)} onClose={onClose}>
            
            {
                isAllowNewClient ?
                    <MenuItem onClick={() => {
                        onClose();
                        newClient();
                    }}><ListItemIcon><NewClientIcon /></ListItemIcon><ListItemText>New Client</ListItemText></MenuItem> : ''
            }
            {
                isAllowPreview ?
                    <MenuItem onClick={() => {
                        onClose();
                        view();
                    }}><ListItemIcon><ViewIcon /></ListItemIcon><ListItemText>Preview {name}</ListItemText></MenuItem> : ''
            }
            {
                isAllowDownload ?
                    <MenuItem onClick={() => {
                        onClose();
                        download();
                    }}><ListItemIcon><DownloadIcon /></ListItemIcon><ListItemText>Download {downloadOrDeleteName}</ListItemText></MenuItem> : ''
            }
            
            {
                isAllowNewFolder ?
                    <MenuItem onClick={() => {
                        onClose();
                        create();
                    }}><ListItemIcon><NewIcon /></ListItemIcon><ListItemText>Add New Folder To {name}</ListItemText></MenuItem> : ''
            }
            {
                isAllowRename ?
                    <MenuItem onClick={() => {
                        onClose();
                        rename();
                    }}><ListItemIcon><RenameIcon /></ListItemIcon><ListItemText>Rename {name}</ListItemText></MenuItem> : ''
            }
            {
                isAllowUpload ?
                    <MenuItem onClick={() => {
                        onClose();
                        upload();
                    }}><ListItemIcon><UploadIcon /></ListItemIcon><ListItemText>Upload To {name}</ListItemText></MenuItem> : ''
            }
            {
                isAllowCut ?
                    <MenuItem onClick={() => {
                        onClose();
                        cut();
                    }}><ListItemIcon><DownloadIcon /></ListItemIcon><ListItemText>Cut {downloadOrDeleteName}</ListItemText></MenuItem> : ''
            }
            {
                isAllowPaste ?
                    <MenuItem onClick={() => {
                        onClose();
                        paste();
                    }}><ListItemIcon><DownloadIcon /></ListItemIcon><ListItemText>Paste to {name}</ListItemText></MenuItem> : ''
            }
            {
                isAllowDelete ?
                    <MenuItem onClick={() => {
                        onClose();
                        onDelete();
                    }} color='secondary'> <ListItemIcon><DeleteIcon /></ListItemIcon><ListItemText>Delete {downloadOrDeleteName}</ListItemText></MenuItem> : ''
            }
            {
                <Divider />
            }
        </Menu>
    );
}